export default __webpack_public_path__ + "static/media/upload-icon-bcr.de9b4bdd.svg";